// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"product-badge_badgeContainer__ar_i6","badge":"product-badge_badge__q21VV"};